module.exports = __webpack_public_path__ + "static/undraw_building_blocks_n0nc-201f7a39ac403d1c976734dc94905159.svg";